import { apiFetch } from '@/api'
import { Product } from '@/interfaces'

export const fetchAllProducts = async (): Promise<Product> => (await apiFetch('/products', { method: 'GET' })).data
